/* src/pages/LandingPage.jsx */
import React, { useState, useEffect, useRef } from 'react';
import SimulaBankSEO from './SimulabankSEO';
import '../../styles/landing.css';

import LpNavbar       from '../../components/landing/LpNavbar';
import LpHero         from '../../components/landing/LpHero';
import LpTrustBar     from '../../components/landing/LpTrustBar';
import LpFeatures     from '../../components/landing/LpFeatures';
import LpHowItWorks   from '../../components/landing/LpHowItWorks';
import LpPricing      from '../../components/landing/LpPricing';
import LpTestimonials from '../../components/landing/LpTestimonials';
import LpCta          from '../../components/landing/LpCta';
import LpFooter       from '../../components/landing/LpFooter';

/* ─── Shared button styles ─── */
const btnBase    = { display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8, borderRadius: 'var(--radius-sm)', fontFamily: 'inherit', fontSize: '0.9rem', fontWeight: 600, textDecoration: 'none', border: 'none', cursor: 'pointer' };
export const btnPrimary = { ...btnBase, padding: '12px 28px', background: 'var(--accent)',     color: 'var(--primary)' };
export const btnOutline = { ...btnBase, padding: '12px 28px', background: 'transparent',        color: 'var(--primary)', border: '1.5px solid var(--border)' };
export const btnDark    = { ...btnBase, padding: '12px 28px', background: 'var(--primary)',     color: '#fff' };
export const btnLarge   = { padding: '16px 36px', fontSize: '1rem', borderRadius: 'var(--radius)' };

export default function LandingPage() {
  const [isAnnual, setIsAnnual] = useState(false);
  const revealRefs = useRef([]);

  /* ── Scroll reveal ── */
  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.style.opacity   = '1';
          e.target.style.transform = 'translateY(0)';
        }
      }),
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );
    revealRefs.current.forEach(el => el && obs.observe(el));
    return () => obs.disconnect();
  }, []);

  const addReveal  = el => { if (el && !revealRefs.current.includes(el)) revealRefs.current.push(el); };
  const revealStyle = { opacity: 0, transform: 'translateY(30px)', transition: 'all 0.7s cubic-bezier(0.16,1,0.3,1)' };

  /* ── Smooth scroll ── */
  const scrollTo = id => e => {
    e.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  /* ── Shared props ── */
  const reveal = { addReveal, revealStyle };
  const btns   = { btnPrimary, btnOutline, btnDark, btnLarge };

  return (
    <div className="lp">
      <SimulaBankSEO />

      <LpNavbar      scrollTo={scrollTo} />
      <LpHero        {...reveal} {...btns} scrollTo={scrollTo} />
      <LpTrustBar    />
      <LpFeatures    {...reveal} />
      <LpHowItWorks  {...reveal} />
      <LpPricing     {...reveal} {...btns} isAnnual={isAnnual} setIsAnnual={setIsAnnual} />
      <LpTestimonials {...reveal} />
      <LpCta         {...reveal} {...btns} />
      <LpFooter      />
    </div>
  );
}
